import { AuthorProps } from '../../interfaces/interfaces';

import './styles.scss';

export function Author({ id, sales, avatar }: AuthorProps) {
  return (
    <div className="itens-container-author">
      <div className="author-wrapper">
        <div className="user-info">
          <img className="imgimg" src={avatar} alt={id} />
          <span className="title-name">
            {id}
          </span>
          <span className="title-sold">
            {sales} {sales > 1 ? 'PARES' : 'PAR'}
          </span>
        </div>
      </div>
    </div>
  );
}